<template>
    <div class="row">
        <div class="footerText">
            <p>
                System is licensed for authorized customers.<br />
                Unauthorized use subject to legal recourse.<br />
                © {{ utcYear }}, ® &amp; Powered by
                <a class="footer" href="http://qrcodeexperts.com">JT.ADMAN. QRCodeExperts.net</a>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "FooterBlock",
    computed: {
        utcYear() {
            return new Date().getUTCFullYear();
        },
    },
}
</script>

<style scoped>
.footerText {
    text-align: center;
    font-size: 1.3em;
}
</style>
